export const tipDataByRole = {
  "Owner": [
    { 
      title: "Manage Students", 
      tip: "Quickly register new students and include photos on the Students screen to ensure easier and quicker identification during data collection.",
      route: "/admin/students" 
    },
    { 
      title: "Organize Teachers and Students into Groups", 
      tip: "Use the Groups screen to create and manage specific groups for better organization of classes and teaching teams.",
      route: "/admin/groups" 
    },
    { 
      title: "Personalize Your Profile", 
      tip: "Click on your profile picture to access the user-profile settings and upload a new photo for easier identification by your team.",
      route: "/admin/user-profile" 
    },
    { 
      title: "Review App Usage Data", 
      tip: "Regularly check the App Report to see protocols data.",
      route: "/admin/appreport" 
    },
  ],
  "Adm": [
    { 
      title: "Register New Students", 
      tip: "Register new students on the Students screen, ensuring you include a photo for each to facilitate teacher identification during daily tasks.",
      route: "/admin/students" 
    },
    { 
      title: "Create and Manage Groups", 
      tip: "Organize students and teachers efficiently by creating custom Groups for classes, intervention teams, or specific projects.",
      route: "/admin/groups" 
    },
    { 
      title: "Review App Usage Data", 
      tip: "Regularly check the App Report to see protocols data.",
      route: "/admin/" 
    },
    { 
      title: "Personalize Your Profile", 
      tip: "Click on your profile picture to access the user-profile settings and upload a new photo for better team recognition.",
      route: "/admin/user-profile" 
    }
  ],
  "Teacher": [
    { 
      title: "Review App Usage Data", 
      tip: "Regularly check the App Report to see protocols data.",
      route: "/admin/appreport" 
    },
    { 
      title: "Personalize Your Profile", 
      tip: "Click on your profile picture to upload a new photo, making it easier for colleagues and admins to identify you.",
      route: "/admin/user-profile" 
    },
    
  ],
  "Master": [
    { 
      title: "Não há dicas para o master", 
      tip: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      route: "/admin/appreport" 
    },
  ]
};